import React, {useEffect, useState} from 'react';
import TextField from "../components/TextField";
import {useLocation, useNavigate} from "react-router-dom";
import {PulseLoader} from "react-spinners";
import logo from "../assets/logo.png" 
import {useLogin} from "../hooks/login/useLogin";
import {useAtom} from "jotai";
import {userAtom, userTokenAtom} from "../atoms/globalStates";


const Login = () => {
    const [password, setPassword] = useState("")
    const [username, setUsername] = useState("");
    const [err, setErr] = useState('')
    const navigate = useNavigate()
    const location = useLocation();
    const [, setUserData] = useAtom(userAtom);
    const [, setUserToken] = useAtom(userTokenAtom);
    const {mutate: login, data, error, isLoading,isSuccess} = useLogin();
    const [fakeLoading, setFakeLoading] = useState(false);

    const handleLogin = (e) => {
        e.preventDefault()
        login({username, password})
        setPassword('')
        setUsername('')
    }

    useEffect(() => {
       
        if (isSuccess) {
            setUserData(data.data?.user);
            setUserToken(data.data?.token)
            navigate("/", {replace: true})
        }
    }, [data,isSuccess])

    useEffect(() => {
        if (error) {
            setErr(error?.response?.data?.message)
        }
        if (username || password) {
            setErr('')
        }
    }, [error, password, username])

    const fakeLogin = (e) => {
        e.preventDefault();
        if (username && password) {
            const path = location.state?.from?.pathname ?? "/"
            setFakeLoading(true)
            setUserData({username, password});
            setTimeout(() => {
                setPassword('')
                setUsername('')
                setFakeLoading(false)
                navigate(path, {replace: true})
            }, 3000)
        }
    }

    return (
        <div className="min-h-screen min-w-full flex flex-col items-center justify-center px-2 select-none bg-gray-100">
           <img style={{width:"80px",height:"80px",borderRadius:10}} src={logo} alt="Fms logo"/> 
            <p className="text-2xl bg-clip-text text-transparent bg-gradient-to-r from-[#0A0D36] to-[#b13f04] font-medium mt-2"> {/* FMS ADMIN  */}</p>
            <section className="bg-white rounded-md border shadow-md p-6 w-full md:w-2/3 lg:w-2/5 xl:w-[550px] mt-4">
                {err && <p className="text-start text-sm text-red-600">{err}</p>}
                <form className="flex flex-col space-y-3" onSubmit={handleLogin}>
                    <TextField label="Username" autoComplete="off" required onChange={e => setUsername(e.target.value)}
                               value={username}/>
                    <TextField label="Password" type="password" required onChange={e => setPassword(e.target.value)}
                               value={password}/>
                    <div className="pt-2">
                        <button type="submit" className="rounded p-1.5 text-white bg-[#0A0D36] w-full font-medium"
                                disabled={isLoading}>
                            <PulseLoader loading={isLoading || fakeLoading} size={16} color="#fff"/>
                            {(!isLoading && !fakeLoading) && "Login"}
                        </button>
                    </div>
                </form>
            </section>
        </div>
    )
};

export default Login;